import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEIndustrialCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Industrial Engineering and Management",
    shortName: "B.E. Industrial",
    duration: "4 years",
    description: "Engineering program combining technical skills with management principles for optimizing industrial systems and operations",
    overview: "Bachelor of Engineering in Industrial Engineering and Management (B.E. Industrial) is a 4-year undergraduate program that bridges engineering and management. This interdisciplinary course focuses on optimizing complex systems, improving productivity, reducing costs, and managing industrial operations efficiently through scientific methods and managerial principles.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in systems optimization and management"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Industrial Engineering",
          "Management Principles"
        ]
      },
      {
        year: 2,
        subjects: [
          "Operations Research",
          "Statistics and Probability",
          "Material Science",
          "Engineering Economics",
          "Work Study and Method Engineering",
          "Human Resource Management"
        ]
      },
      {
        year: 3,
        subjects: [
          "Production Planning and Control",
          "Quality Engineering",
          "Facility Planning and Design",
          "Supply Chain Management",
          "Project Management",
          "Financial Management"
        ]
      },
      {
        year: 4,
        subjects: [
          "Industrial Safety and Environment",
          "Automation and Control Systems",
          "Lean Manufacturing and Six Sigma",
          "Strategic Management",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Industrial Engineer",
        "Operations Manager",
        "Production Manager",
        "Quality Manager",
        "Process Improvement Engineer",
        "Supply Chain Analyst",
        "Management Consultant",
        "Project Manager"
      ],
      industries: [
        "Manufacturing Industries",
        "Healthcare Systems",
        "Logistics and Transportation",
        "Banking and Financial Services",
        "IT and Software Services",
        "Retail and E-commerce",
        "Consulting Firms",
        "Government Organizations"
      ],
      averageSalary: "₹5-9 LPA (Fresher), ₹15-35 LPA (Experienced)",
      topRecruiters: [
        "McKinsey, Deloitte, Accenture",
        "Amazon, Flipkart",
        "TCS, Infosys, Wipro",
        "L&T, Godrej",
        "ICICI Bank, HDFC",
        "Mahindra, Tata Group"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Coimbatore Institute of Technology",
        location: "Coimbatore",
        fees: "₹3,80,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Madras Institute of Technology, Anna University",
        location: "Chennai",
        fees: "₹2,20,000",
        ranking: "NIRF Ranking: 48"
      }
    ],

    skills: [
      "Operations Research",
      "Data Analysis and Statistics",
      "Project Management",
      "Lean Six Sigma",
      "Supply Chain Optimization",
      "Financial Analysis",
      "Leadership and Communication",
      "Problem Solving",
      "Systems Thinking",
      "Strategic Planning"
    ],

    futureScope: "Excellent career prospects in the growing economy with focus on optimization, efficiency, and digital transformation across all industries.",

    faqs: [
      {
        question: "Can Industrial Engineers work in IT companies?",
        answer: "Yes, many IT companies hire Industrial Engineers for process optimization, project management, operations, and business analysis roles."
      },
      {
        question: "Is this more management or engineering focused?",
        answer: "It's a balanced combination of both technical engineering skills and management principles, making graduates versatile professionals."
      },
      {
        question: "What about MBA prospects?",
        answer: "Industrial Engineering provides excellent foundation for MBA programs, especially in Operations, Strategy, and General Management."
      },
      {
        question: "Are there opportunities in startups?",
        answer: "Yes, startups value Industrial Engineers for setting up efficient processes, scaling operations, and managing resources effectively."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEIndustrialCoursePage;
